<template>
  <div class="container-fluid p-2 p-md-3 fondo-color-01 min-vh-100">
    <div class="container py-3 py-md-4">
      <h1 class="text-white text-center mb-3 mb-md-4 page-title">Confirmar pedido</h1>

      <div class="row g-4 justify-content-center">

        <!-- Resumen del carrito -->
        <div class="col-12 col-md-5">
          <div class="order-card">
            <h5 class="order-card__title">Tu pedido</h5>

            <p v-if="carritoItems.length === 0" class="text-muted text-center py-3">
              El carrito está vacío
            </p>

            <ul v-else class="order-list">
              <li v-for="item in carritoItems" :key="item.product" class="order-list__item">
                <div class="order-list__info">
                  <span class="order-list__name">{{ item.product }}</span>
                  <div class="order-list__controls">
                    <button class="ctrl-btn" @click="removeItem(item)">−</button>
                    <span class="ctrl-qty">{{ item.quantity }}</span>
                    <button class="ctrl-btn" @click="addItem(item)">+</button>
                    <button class="ctrl-btn ctrl-btn--delete" @click="deleteItem(item)" title="Eliminar">✕</button>
                  </div>
                </div>
                <span class="order-list__subtotal">${{ item.total }}</span>
              </li>
            </ul>

            <div class="order-total">
              <span>Total</span>
              <span class="order-total__amount">${{ total }}</span>
            </div>

            <router-link to="/" class="btn btn-outline-secondary w-100 mt-3">
              ← Seguir agregando productos
            </router-link>
          </div>
        </div>

        <!-- Formulario de envío -->
        <div class="col-12 col-md-7">
          <div class="order-card">
            <h5 class="order-card__title">Datos de envío</h5>

            <div class="mb-3">
              <label class="form-label">Calle principal</label>
              <input v-model="address.street_1" class="form-control" type="text" placeholder="Ej. Av. Insurgentes">
            </div>

            <div class="mb-3">
              <label class="form-label">Cruzamientos</label>
              <input v-model="address.street_2" class="form-control" type="text" placeholder="Entre calles">
            </div>

            <div class="row mb-3">
              <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                <label class="form-label">Número</label>
                <input v-model="address.number_ext" class="form-control" type="text" placeholder="# de casa">
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label">Colonia</label>
                <select v-model="coloniaIdx" class="form-select form-control">
                  <option :value="null" disabled>Selecciona tu colonia</option>
                  <option v-for="(col, idx) in colonias" :key="idx" :value="idx">
                    {{ col.nombre }}
                  </option>
                </select>
                <small v-if="coloniaActual" class="text-muted">C.P. {{ coloniaActual.cp }}</small>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Teléfono</label>
              <input v-model="address.tel" class="form-control" type="tel" placeholder="10 dígitos" maxlength="10">
            </div>

            <div class="mb-4">
              <label class="form-label">Notas del pedido</label>
              <textarea v-model="address.extra_info" rows="3" placeholder="Ej. maciza, surtido, sin salsa..." class="form-control"></textarea>
            </div>

            <button class="btn btn-whatsapp w-100" @click="saveOrder">
              Enviar pedido por WhatsApp
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.page-title {
  font-size: 1.5rem;
}
@media (min-width: 768px) {
  .page-title { font-size: 2rem; }
}

.order-card {
  background: #fff;
  border-radius: 14px;
  padding: 1rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}
@media (min-width: 768px) {
  .order-card { padding: 1.5rem; }
}

.order-card__title {
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f0f0f0;
  color: #333;
}

.order-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}
.order-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f0f0f0;
}
.order-list__item:last-child { border-bottom: none; }
.order-list__info { display: flex; flex-direction: column; gap: 0.4rem; }
.order-list__name { font-weight: 600; font-size: 0.95rem; color: #222; }
.order-list__subtotal { font-weight: 600; color: #2c7a2c; white-space: nowrap; }

.order-list__controls {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.ctrl-btn {
  width: 26px;
  height: 26px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 0.95rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.ctrl-btn:hover { background: #e0e0e0; }
.ctrl-btn--delete {
  border-color: #e57373;
  color: #e53935;
  background: #fff0f0;
  margin-left: 0.25rem;
  font-size: 0.7rem;
}
.ctrl-btn--delete:hover { background: #ffd6d6; }
.ctrl-qty {
  min-width: 1.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.95rem;
}

.order-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.75rem;
  border-top: 2px solid #eee;
  font-weight: 700;
  font-size: 1.1rem;
  color: #222;
}
.order-total__amount {
  font-size: 1.2rem;
  color: #2c7a2c;
}
@media (min-width: 768px) {
  .order-total__amount { font-size: 1.4rem; }
}

.form-label {
  font-weight: 600;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 0.3rem;
}

.btn-whatsapp {
  background-color: #25d366;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.75rem;
  border-radius: 10px;
  border: none;
}
.btn-whatsapp:hover {
  background-color: #1da851;
  color: #fff;
}
</style>

<script>
import { Message } from "@/services/Messages"

export default {
  name: 'OrderForm',
  data() {
    return {
      coloniaIdx: null,
      address: {
        street_1: '',
        street_2: '',
        number_ext: '',
        tel: '',
        extra_info: '',
      },
      total: this.getTotalCarrito(),
      carrito: this.getCarrito(),
      colonias: [
        { nombre: "1 (ASENTAMIENTO)", cp: "77014" },
        { nombre: "17 DE OCTUBRE", cp: "77086" },
        { nombre: "AARON MERINO FERNANDEZ", cp: "77070" },
        { nombre: "ADOLFO LOPEZ MATEOS", cp: "77010" },
        { nombre: "ALVARO OBREGON 1 Y 2", cp: "77050" },
        { nombre: "ALVARO OBREGON II", cp: "77050" },
        { nombre: "AMPLIACION BICENTENARIO", cp: "77086" },
        { nombre: "AMPLIACION NUEVA GENERACION", cp: "77086" },
        { nombre: "ANDARA CLUB RESIDENCIAL", cp: "77014" },
        { nombre: "ANDRES QUINTANA ROO", cp: "77086" },
        { nombre: "ARBOLEDAS", cp: "77086" },
        { nombre: "ARBOLEDAS II", cp: "77086" },
        { nombre: "ASERRADERO", cp: "77037" },
        { nombre: "AVANCEMOS JUNTOS", cp: "77018" },
        { nombre: "BAHIA", cp: "77079" },
        { nombre: "BARRIO BRAVO", cp: "77098" },
        { nombre: "BENITO JUAREZ", cp: "77037" },
        { nombre: "BICENTENARIO", cp: "77086" },
        { nombre: "BOSQUES DEL LAGO", cp: "77029" },
        { nombre: "BUGAMBILIAS", cp: "77010" },
        { nombre: "CAMPESTRE", cp: "77030" },
        { nombre: "CARIBE", cp: "77086" },
        { nombre: "CARIBE II", cp: "77086" },
        { nombre: "CARIBE II BIS", cp: "77086" },
        { nombre: "CARIBE IV", cp: "77086" },
        { nombre: "CARIBE V", cp: "77086" },
        { nombre: "CARIBE VI", cp: "77086" },
        { nombre: "CASCADA I", cp: "77050" },
        { nombre: "CASCADA II", cp: "77050" },
        { nombre: "CEDROS", cp: "77024" },
        { nombre: "CENTENARIO", cp: "77014" },
        { nombre: "CENTENARIO II", cp: "77014" },
        { nombre: "CENTRO", cp: "77000" },
        { nombre: "CINCO DE ABRIL", cp: "77018" },
        { nombre: "COMITE", cp: "77086" },
        { nombre: "COMITE PROTERRITORIO", cp: "77086" },
        { nombre: "CONSTITUYENTES", cp: "77015" },
        { nombre: "DAVID GUSTAVO GUTIERREZ RUIZ", cp: "77013" },
        { nombre: "DEL BOSQUE (C.P. 77019)", cp: "77019" },
        { nombre: "DEL BOSQUE (C.P. 77086)", cp: "77086" },
        { nombre: "DEL MAR", cp: "77010" },
        { nombre: "DEL SOL", cp: "77086" },
        { nombre: "EDIFICACION ESTRELLA", cp: "77083" },
        { nombre: "EL ENCANTO", cp: "77086" },
        { nombre: "EL SOL", cp: "77026" },
        { nombre: "EMANCIPACION", cp: "77084" },
        { nombre: "ENRIQUE RAMIREZ Y RAMIREZ", cp: "77023" },
        { nombre: "FELIX GONZALEZ CANTO", cp: "77086" },
        { nombre: "FIDEL VELAZQUEZ", cp: "77080" },
        { nombre: "FLAMBOYANES", cp: "77034" },
        { nombre: "FLAMINGOS", cp: "77014" },
        { nombre: "FLAMINGOS IV", cp: "77014" },
        { nombre: "FORJADORES", cp: "77025" },
        { nombre: "FOVISSSTE I RAFAEL E. MELGAR", cp: "77020" },
        { nombre: "FOVISSSTE II RAFAEL E. MELGAR", cp: "77024" },
        { nombre: "FOVISSSTE III JOSE LOPEZ PORTILLO", cp: "77024" },
        { nombre: "FOVISSSTE IV ETAPA (JARDIN)", cp: "77026" },
        { nombre: "FOVISSSTE ISSSTE", cp: "77050" },
        { nombre: "FOVISSSTE V ETAPA (ESTATUTO JURIDICO)", cp: "77049" },
        { nombre: "FOVISSSTE VI ETAPA (TAMPICO)", cp: "77079" },
        { nombre: "FRANCISCO J. MUJICA", cp: "77010" },
        { nombre: "FSTSE", cp: "77014" },
        { nombre: "GONZALO GUERRERO", cp: "77020" },
        { nombre: "GUADALUPE VICTORIA", cp: "77025" },
        { nombre: "HACIENDA CHETUMAL", cp: "77085" },
        { nombre: "HERMANOS FLORES MAGON", cp: "77050" },
        { nombre: "ING. MARIO ERNESTO VILLANUEVA MADRID", cp: "77086" },
        { nombre: "INSURGENTES", cp: "77029" },
        { nombre: "INSURGENTES IV-B", cp: "77084" },
        { nombre: "ISABEL TENORIO", cp: "77010" },
        { nombre: "ITALIA", cp: "77035" },
        { nombre: "JARDINES", cp: "77026" },
        { nombre: "JARDINES DE PAYO OBISPO", cp: "77082" },
        { nombre: "JAVIER ROJO GOMEZ", cp: "77080" },
        { nombre: "JESUS MARTINEZ ROSS", cp: "77016" },
        { nombre: "JOSEFA ORTIZ DE DOMINGUEZ", cp: "77036" },
        { nombre: "KM 5", cp: "77082" },
        { nombre: "LA ESPERANZA", cp: "77086" },
        { nombre: "LA ISLA", cp: "77010" },
        { nombre: "LA PRIMAVERA", cp: "77086" },
        { nombre: "LA SABANA (LOS MONOS)", cp: "77029" },
        { nombre: "LAGUNITAS", cp: "77029" },
        { nombre: "LAS AMERICAS", cp: "77086" },
        { nombre: "LAS AMERICAS I", cp: "77086" },
        { nombre: "LAS AMERICAS II", cp: "77086" },
        { nombre: "LAS AMERICAS II BIS", cp: "77086" },
        { nombre: "LAS AMERICAS III", cp: "77086" },
        { nombre: "LAS BRISAS", cp: "77079" },
        { nombre: "LAZARO CARDENAS", cp: "77086" },
        { nombre: "LEONA VICARIO", cp: "77016" },
        { nombre: "LEY FEDERAL DE AGUAS", cp: "77017" },
        { nombre: "LOMAS DEL CARIBE", cp: "77053" },
        { nombre: "LOS ALMENDROS", cp: "77025" },
        { nombre: "LOS ALMENDROS II ETAPA", cp: "77025" },
        { nombre: "LOS ENCINOS", cp: "77086" },
        { nombre: "LOS MUSICOS", cp: "77086" },
        { nombre: "MAGISTERIAL", cp: "77039" },
        { nombre: "MAYA REAL", cp: "77084" },
        { nombre: "MILENIO", cp: "77025" },
        { nombre: "MILITAR", cp: "77060" },
        { nombre: "MIRAFLORES (C.P. 77023)", cp: "77023" },
        { nombre: "MIRAFLORES (C.P. 77027)", cp: "77027" },
        { nombre: "NAVAL", cp: "77010" },
        { nombre: "NO DEFINIDA (10X20)", cp: "77000" },
        { nombre: "NO DEFINIDA (100X150)", cp: "77000" },
        { nombre: "NO DEFINIDA (20X30)", cp: "77000" },
        { nombre: "NO DEFINIDA BOULEVARD (50X100)", cp: "77019" },
        { nombre: "NO DEFINIDA CHET CARR.FED. (100X100)", cp: "77000" },
        { nombre: "NO DEFINIDA INSURGENTES-LAGUNITAS (100X)", cp: "77029" },
        { nombre: "NUEVA GENERACION", cp: "77086" },
        { nombre: "NUEVO PROGRESO", cp: "77083" },
        { nombre: "OCHO DE OCTUBRE", cp: "77028" },
        { nombre: "PACTO OBRERO CAMPESINO", cp: "77014" },
        { nombre: "PACTO OBRERO CAMPESINO III", cp: "77014" },
        { nombre: "PARQUE INDUSTRIAL", cp: "77015" },
        { nombre: "PARQUE INDUSTRIAL D.M.S.", cp: "77086" },
        { nombre: "PAYO OBISPO", cp: "77084" },
        { nombre: "PAYO OBISPO I ETAPA", cp: "77083" },
        { nombre: "PAYO OBISPO II ETAPA", cp: "77083" },
        { nombre: "PLUTARCO ELIAS CALLES (C.P. 77028)", cp: "77028" },
        { nombre: "PLUTARCO ELIAS CALLES (C.P. 77090)", cp: "77090" },
        { nombre: "PRIMERA LEGISLATURA", cp: "77099" },
        { nombre: "PROTERRITORIO", cp: "77086" },
        { nombre: "PROTERRITORIO V", cp: "77086" },
        { nombre: "PROTERRITORIO VI", cp: "77086" },
        { nombre: "PROTERRITORIO VII", cp: "77086" },
        { nombre: "PROTERRITORIO VIII", cp: "77086" },
        { nombre: "PROTERRITORIO VIII ETAPA", cp: "77086" },
        { nombre: "REAL BAHIA", cp: "77079" },
        { nombre: "REAL CARIBE", cp: "77083" },
        { nombre: "REFORMA 1977", cp: "77018" },
        { nombre: "RESIDENCIAL BOSQUE REAL", cp: "77086" },
        { nombre: "RESIDENCIAL CHETUMAL", cp: "77086" },
        { nombre: "RESIDENCIAL CHETUMAL II", cp: "77086" },
        { nombre: "RESIDENCIAL CHETUMAL IV", cp: "77086" },
        { nombre: "RESIDENCIAL CONSTITUYENTES", cp: "77086" },
        { nombre: "RESIDENCIAL CUMBRES", cp: "77084" },
        { nombre: "RESIDENCIAL LA HERRADURA", cp: "77050" },
        { nombre: "RESIDENCIAL LA HERRADURA II", cp: "77050" },
        { nombre: "RESIDENCIAL LA HERRADURA III", cp: "77050" },
        { nombre: "RESIDENCIAL LAS AMERICAS", cp: "77086" },
        { nombre: "RESIDENCIAL MARSELLA", cp: "77025" },
        { nombre: "RESIDENCIAL MARSELLA II", cp: "77020" },
        { nombre: "RESIDENCIAL MEDITERRANEO", cp: "77086" },
        { nombre: "RESIDENCIAL SIAN KA-AN", cp: "77086" },
        { nombre: "RESIDENCIAL SIAN KA-AN II", cp: "77086" },
        { nombre: "RESIDENCIAL SIAN KA-AN III", cp: "77086" },
        { nombre: "S.A.H.O.P.", cp: "77017" },
        { nombre: "SANTA ISABEL (CERESO)", cp: "77040" },
        { nombre: "SANTA MARIA", cp: "77014" },
        { nombre: "SOLIDARIDAD", cp: "77086" },
        { nombre: "SOLIDARIDAD SOLIDARIDAD", cp: "77086" },
        { nombre: "TAMALCAB", cp: "77083" },
        { nombre: "TAXISTAS", cp: "77037" },
        { nombre: "TERRITORIO FEDERAL DE QUINTANA ROO", cp: "77086" },
        { nombre: "TUMBEN CUXTAL", cp: "77026" },
        { nombre: "UNIDAD ANTORCHISTA", cp: "77014" },
        { nombre: "VEINTE DE NOVIEMBRE", cp: "77038" },
        { nombre: "VENUSTIANO CARRANZA (LAS CASITAS)", cp: "77012" },
        { nombre: "VILLAS CHETUMAL", cp: "77059" },
        { nombre: "VILLAS KINICHNA", cp: "77014" },
        { nombre: "VILLAS OXTANKAH", cp: "77014" },
        { nombre: "VILLAS UNIVERSITARIAS", cp: "77014" },
        { nombre: "YAX-CHE RESIDENCIAL", cp: "77014" },
        { nombre: "ZAZIL-HA", cp: "77079" },
        { nombre: "ZONA DE GRANJAS", cp: "77079" },
        { nombre: "ZONA INDUSTRIAL II", cp: "77015" },
      ]
    }
  },
  computed: {
    carritoItems() {
      return Object.values(this.carrito);
    },
    coloniaActual() {
      return this.coloniaIdx !== null ? this.colonias[this.coloniaIdx] : null;
    }
  },
  methods: {
    saveOrder() {
      let message = new Message();

      const lineas = this.carritoItems.map(item =>
        `  • ${item.quantity}x ${item.product} — $${item.total}`
      ).join('\n');

      const colonia = this.coloniaActual
        ? `${this.coloniaActual.nombre}, C.P. ${this.coloniaActual.cp}`
        : 'No especificada';

      const partes = [
        `*NUEVO PEDIDO — CARNITAS EL COMPADRE*`,
        ``,
        `*Productos:*`,
        lineas,
        ``,
        `*Total: $${this.total}*`,
        ``,
        `*Datos de entrega:*`,
        `  Calle: ${this.address.street_1} entre ${this.address.street_2}`,
        `  Núm.: ${this.address.number_ext}`,
        `  Colonia: ${colonia}`,
        `  Tel.: ${this.address.tel}`,
      ];

      if (this.address.extra_info) {
        partes.push(``, `*Notas:* ${this.address.extra_info}`);
      }

      let phone_local = "9831338167"
      window.open(message.send_message(phone_local, partes.join('\n')));
    },
    getTotalCarrito() {
      let totalCarrito = localStorage.getItem('total_carrito');
      if (totalCarrito == null || isNaN(totalCarrito)) {
        totalCarrito = 0;
      }
      return parseInt(totalCarrito)
    },
    getCarrito() {
      let carrito = localStorage.getItem('carrito');
      if (carrito == undefined || carrito == null) {
        carrito = '{}';
      }
      return JSON.parse(carrito);
    },
    saveCarrito() {
      localStorage.setItem('carrito', JSON.stringify(this.carrito));
      this.total = Object.values(this.carrito).reduce((sum, i) => sum + i.total, 0);
      localStorage.setItem('total_carrito', this.total);
    },
    addItem(item) {
      const qty = item.quantity + 1;
      this.carrito[item.product] = { ...item, quantity: qty, total: item.price * qty };
      this.saveCarrito();
    },
    removeItem(item) {
      if (item.quantity <= 1) {
        this.deleteItem(item);
        return;
      }
      const qty = item.quantity - 1;
      this.carrito[item.product] = { ...item, quantity: qty, total: item.price * qty };
      this.saveCarrito();
    },
    deleteItem(item) {
      delete this.carrito[item.product];
      this.saveCarrito();
    },
  },
  components: {}
}
</script>